import { useState, useContext, useEffect } from 'react';
import { StateContext } from '../../StateContainer';
import ModalVariables from '../modal/ModalVariables';
import Select from 'react-select';
import axios from 'axios';

const GenerazioneOutput = ({
  closeModal,
  setCurrentTab,
  dettagliNodi,
  selectedNode,
  setDettagliNodi,
}) => {
  const { showModalVariables, token, setLoading, setError } =
    useContext(StateContext);

  const [variableOptions, setVariableOptions] = useState([
    { value: '', label: "Seleziona un'opzione" },
    { value: 'internal', label: 'Usa conoscenza interna' },
  ]);

  const nodoKey = `nodo-${selectedNode.id}`;
  const nodoDetails = dettagliNodi[nodoKey] || {};
  const contextualData = nodoDetails.output?.contextual_response || {};

  const [isWebserviceOn, setIsWebserviceOn] = useState(
    contextualData.use_webservice_output || false
  );

  const [selectedOption, setSelectedOption] = useState({
    value: '',
    label: "Seleziona un'opzione",
  });

  const [contextualInstructions, setContextualInstructions] = useState(
    contextualData.contextual_response_instructions || ''
  );

  useEffect(() => {
    setLoading(true);
    axios({
      method: 'post',
      url: `${process.env.REACT_APP_BASE_URL}/project/list`,
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + token,
      },
    })
      .then((response) => {
        setLoading(false);
        setError('');
        const projects = response.data.response.projects;

        if (projects && projects.length > 0) {
          const newOptions = projects.map((project) => ({
            value: project.code,
            label: `Usa conoscenza progetto "${project.title}"`,
          }));

          setVariableOptions((prevOptions) => [...prevOptions, ...newOptions]);
        }
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          localStorage.removeItem('token');
          localStorage.removeItem('tokenExpiration');
          window.location.replace('/login');
        }
      });
  }, []);

  const handleWebserviceToggle = () => {
    setIsWebserviceOn((prev) => {
      const newValue = !prev;
      setDettagliNodi((prevDettagli) => {
        const node = { ...prevDettagli[nodoKey] };
        node.output = node.output || {};
        node.output.contextual_response = node.output.contextual_response || {};
        node.output.contextual_response.use_webservice_output = newValue;
        return { ...prevDettagli, [nodoKey]: node };
      });
      return newValue;
    });
  };

  const handleSelectChange = (option) => {
    setSelectedOption(option);
    setDettagliNodi((prev) => {
      const newDetails = { ...prev[nodoKey] };
      newDetails.output = newDetails.output || {};
      newDetails.output.contextual_response =
        newDetails.output.contextual_response || {};

      if (option.value === '') {
        delete newDetails.output.contextual_response.use_knowledgebase;
      } else {
        newDetails.output.contextual_response.use_knowledgebase = option.value;
      }

      return { ...prev, [nodoKey]: newDetails };
    });
  };

  const handleTextareaChange = (e) => {
    const newValue = e.target.value;
    setContextualInstructions(newValue);
    setDettagliNodi((prevDettagli) => {
      const node = { ...prevDettagli[nodoKey] };
      node.output = node.output || {};
      node.output.contextual_response = node.output.contextual_response || {};
      node.output.contextual_response.contextual_response_instructions =
        newValue;
      return { ...prevDettagli, [nodoKey]: node };
    });
  };

  useEffect(() => {
    const value = contextualData.use_knowledgebase;
    if (value) {
      const existingOption = variableOptions.find(
        (option) => option.value === value
      );
      if (existingOption) {
        setSelectedOption(existingOption);
      }
    }

    // Sync contextual_instructions from dettagliNodi
    setContextualInstructions(
      contextualData.contextual_response_instructions || ''
    );
  }, [dettagliNodi, variableOptions]);

  return (
    <>
      {!showModalVariables ? (
        <div className="row my-3" style={{ height: '530px' }}>
          <div className="widget-tabs col-12 d-flex flex-column">
            <div className="d-flex align-items-center gap-2 justify-content-start">
              <label>Usa risposta servizio esterno</label>
              <div className="form-check form-switch py-0">
                <input
                  className="form-check-input"
                  type="checkbox"
                  role="switch"
                  checked={isWebserviceOn}
                  onChange={handleWebserviceToggle}
                />
              </div>
            </div>

            <Select
              options={variableOptions}
              placeholder="Cerca..."
              isSearchable
              value={selectedOption}
              onChange={handleSelectChange}
            />

            <div className="py-2">
              <label>Istruzioni contestuali</label>
              <textarea
                className="w-100 rounded"
                value={contextualInstructions}
                onChange={handleTextareaChange}
                rows={6}
              />
            </div>
          </div>
        </div>
      ) : (
        <ModalVariables
          closeModal={closeModal}
          setCurrentTab={setCurrentTab}
          dettagliNodi={dettagliNodi}
          selectedNode={selectedNode}
          setDettagliNodi={setDettagliNodi}
        />
      )}
    </>
  );
};

export default GenerazioneOutput;
